import { Directive } from '@angular/core';

/**
 * Marker directive for the card-grid slot of `umss-data-view`.
 *
 * Usage:
 * ```html
 * <ng-container umssDataViewCards>
 *   @for (item of dataSource.items; track item.id) {
 *     <umss-card>...</umss-card>
 *   }
 * </ng-container>
 * ```
 */
@Directive({
  selector: '[umssDataViewCards]',
  standalone: true
})
export class UmssDataViewCardsDirective {}
